(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-information"]) return;
  try {
    
  if (!window.fenirVerticalGallery) {
    window.fenirVerticalGallery = true;
    const states = new WeakMap();
    const getGallery = target => target.closest?.('.product-information__media media-gallery[data-presentation="carousel"]');
    const move = (gallery, index) => {
      const scroller = gallery.querySelector('slideshow-slides');
      const slides = [...scroller.children];
      index = Math.max(0, Math.min(index, slides.length - 1));
      scroller.scrollTo({ top: index * scroller.clientHeight, left: 0, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      slides.forEach((slide, i) => slide.setAttribute('aria-hidden', String(i !== index)));
      gallery.querySelectorAll('.slideshow-controls__thumbnail').forEach((button, i) => button.setAttribute('aria-selected', String(i === index)));
      return index;
    };
    document.addEventListener('wheel', event => {
      if (!matchMedia('(min-width: 750px)').matches || event.ctrlKey || Math.abs(event.deltaY) <= Math.abs(event.deltaX)) return;
      const gallery = getGallery(event.target);
      if (!gallery || event.target.closest('dialog')) return;
      const scroller = gallery.querySelector('slideshow-slides');
      if (!scroller || scroller.children.length < 2) return;
      const now = performance.now(), direction = Math.sign(event.deltaY);
      const state = states.get(gallery) || { changed: 0, total: 0, last: 0 };
      const index = Math.round(scroller.scrollTop / scroller.clientHeight);
      const edge = direction < 0 ? index === 0 : index === scroller.children.length - 1;
      if (edge && now - state.last > 180) return;
      event.preventDefault();
      if (now - state.last > 180) state.total = 0;
      state.last = now;
      state.total += Math.abs(event.deltaY) * (event.deltaMode === 1 ? 16 : 1);
      states.set(gallery, state);
      if (now - state.changed < 700 || state.total < 45 || edge) return;
      state.changed = now; state.total = 0;
      move(gallery, index + direction);
    }, { passive: false, capture: true });
    document.addEventListener('click', event => {
      if (!matchMedia('(min-width: 750px)').matches) return;
      const gallery = getGallery(event.target);
      const control = event.target.closest?.('.slideshow-controls__thumbnail, button[ref="next"], button[ref="previous"]');
      if (!gallery || !control) return;
      event.preventDefault(); event.stopImmediatePropagation();
      const scroller = gallery.querySelector('slideshow-slides');
      const thumbs = [...gallery.querySelectorAll('.slideshow-controls__thumbnail')];
      const index = thumbs.includes(control) ? thumbs.indexOf(control) : Math.round(scroller.scrollTop / scroller.clientHeight) + (control.getAttribute('ref') === 'next' ? 1 : -1);
      move(gallery, index);
    }, true);
  }

  } catch(e) { console.error(e); }
})();
})();
